export const LAB_USER_EMAIL = "lab@inlab-genetics.ru";

export function isLabUserEmail(email?: string | null): boolean {
    return email === LAB_USER_EMAIL;
}
